import axios from "axios";
import type { VoucherListParams, VoucherListResponse } from "./VoucherSlice";

export const fetchVoucherListApi = async (
  params: VoucherListParams
): Promise<VoucherListResponse> => {
  const token = localStorage.getItem("accessToken");
  const { append, ...rest } = params;
  const requestBody: Record<string, unknown> = { ...rest };

  const response = await axios.request({
    baseURL: `${window.env.API_URL}/api/v1/vouchers/list`,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    method: "POST",
    data: requestBody,
  });

  return { ...response.data, append };
};
